/**
 * Legenda de cores de urgência do prazo (SLA).
 *  - Vermelho  → urgente (≤3 dias ou vencido)
 *  - Amarelo   → vence na semana (4–7 dias)
 *  - Neutro    → não urgente (≥8 dias)
 */
export function Legenda() {
  const items: { cor: string; label: string; ring?: boolean }[] = [
    { cor: '#dc2626', label: 'Urgente'         },
    { cor: '#d97706', label: 'Vence na semana' },
    { cor: '#cbd5e1', label: 'Não urgente', ring: true },
  ];

  return (
    <div className="flex items-center gap-3 text-[11px] text-gray-600 dark:text-gray-400 overflow-x-auto">
      <span className="font-medium text-gray-500 dark:text-gray-400 flex-shrink-0">
        Prazo:
      </span>
      {items.map(({ cor, label, ring }) => (
        <span key={label} className="flex items-center gap-1.5 flex-shrink-0">
          <span
            className={`w-2.5 h-2.5 rounded-sm flex-shrink-0 ${ring ? 'ring-1 ring-slate-300 dark:ring-slate-600' : ''}`}
            style={{ background: cor }}
          />
          {label}
        </span>
      ))}
    </div>
  );
}
